export class RealDOM<T = HTMLElement> {
    private _dom?: T;

    public get dom(): T | null {
        return this._dom as any;
    }

    constructor() {
        this.setDom = this.setDom.bind(this);
    }

    public setDom(dom) {
        this._dom = dom;
    }
}
